import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { ShowcaseRoomConfig } from '@api/showcase-room'

import { RootStateTypeExtra } from '../types'

const initialState = {} as ShowcaseRoomConfig

const showcaseRoomSlice = createSlice({
  name: 'showcaseRoom',
  initialState,
  reducers: {
    setShowcaseRoomConfig: (
      state: ShowcaseRoomConfig,
      action: PayloadAction<ShowcaseRoomConfig>
    ) => ({
      ...state,
      ...action.payload,
    }),
  },
})

export const { setShowcaseRoomConfig } = showcaseRoomSlice.actions

export const selectShowcaseRoomConfig = (state: RootStateTypeExtra) =>
  state.showcaseRoom

export default showcaseRoomSlice.reducer
